"use client";
import React from "react";
import { ContextState } from "./AppContextProvider";
export const AppContext = React.createContext<ContextState>({
  localAppState: {},
  setLocalAppState: () => null,
  localIsDrawerExpandedState: false,
  handleSetLocalIsDrawerExpandedState: () => null,
});
export default AppContext;
